<script>

  import RatingStars from '@/components/RatingStars'
  import isRelativeUrl from '@/mixins/isRelativeUrl'
  import { gtmSendEvent } from '@/utils/gtm-send-event'

  export default {
    components: {
      RatingStars
    },
    mixins: [isRelativeUrl],
    props: {
      fields: {
        type: Object,
        default: () => {},
        required: true
      },
      size: {
        type: String,
        default: ''
      },
      useUserColor: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        hover: false
      }
    },
    computed: {
      tag () {
        return this.isRelativeUrl(this.fields.buttonLink) ? 'nuxt-link' : 'a'
      },
      attrs () {
        let attrs = {}
        if (this.isRelativeUrl(this.fields.buttonLink)) {
          attrs = { to: this.toRelativeUrl(this.fields.buttonLink) }
        } else {
          attrs = {
            href: this.fields.buttonLink,
            target: '_blank'
          }
        }
        return attrs
      },
    },
    methods: {
      trackEvent (fields) {
        gtmSendEvent('call-to-action', 'button-click', fields.buttonLink)
      }
    }
  }
</script>

<template>
  <component
    :is="tag"
    v-bind="attrs"
    class="block mt-8 mb-12 md:my-0 shadow-card bg-white rounded-lg call-to-action md:h-full"
  >
    <div class="p-4 lg:p-7 xl:flex md:h-full xl:items-center xl:flex-row-reverse">
      <img
        v-if="fields.image"
        :src="fields.image.fields.file.url"
        :alt="fields.image.fields.title"
        class="xl:w-1/2"
      >

      <div>
        <h2
          v-if="fields.contentTitle"
          class="my-4 font-semibold text-1xl"
        >
          {{ fields.contentTitle }}
        </h2>
        <p
          v-if="fields.contentText"
          class="mb-4 text-base text-gray-500"
        >
          {{ fields.contentText }}
        </p>

        <e-button
          tag="nuxt-link"
          :to="toRelativeUrl(fields.buttonLink)"
          type="quinary"
          @click.native="trackEvent()"
        >
          {{ fields.buttonText }}
        </e-button>
      </div>
    </div>
  </component>
</template>

<style lang="scss" scoped>
.call-to-action {

  &:hover {
    @apply shadow-focus cursor-pointer;

    .cta-button {
      @apply bg-white;
      color: currentColor;
    }
  }

  h3 + p {
    @apply font-normal mt-2;
  }

  .cta-button {
    @apply rounded inline-block font-bold px-4 py-3 text-white;
    box-shadow: inset 0 0 0 0.125rem rgba(255, 255, 255, 0.8);
    transition: all 0.25s ease(easeOutSine);
  }

  &.large {
    @screen md {
      @apply py-18;
      h3 {
        @apply text-3xl;
      }
      p {
        @apply mx-auto;
        max-width: 20rem;
      }
    }
  }
}
</style>
